import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import useFocusOnMount from 'hooks/useFocusOnMount';
import Button from 'components/Button';
import Stack from 'components/Stack';
import Text from 'components/Text';
import InlineList from 'components/InlineList';
import { CommentSizesContext } from '../Context';
export function DeleteConfirmation(_ref) {
  var id = _ref.id,
    onConfirm = _ref.onConfirm,
    onCancel = _ref.onCancel;
  var _useTranslation = useTranslation(),
    _useTranslation2 = _slicedToArray(_useTranslation, 1),
    t = _useTranslation2[0];
  var buttonRef = useFocusOnMount();
  var size = useContext(CommentSizesContext);
  var isDefaultSize = size === 'DEFAULT';
  var buttonSize = isDefaultSize ? 'small' : 'medium';
  var titleId = "delete-comment-".concat(id);
  return /*#__PURE__*/React.createElement("div", {
    role: "dialog",
    "aria-labelledby": titleId
  }, /*#__PURE__*/React.createElement(Stack, {
    spacing: "xxs",
    pl: "xs"
  }, /*#__PURE__*/React.createElement(Text, {
    as: "p",
    id: titleId,
    size: isDefaultSize ? 'xs' : ['xs', 'm'],
    breakpoints: "m"
  }, t('delete_comment_are_you_sure')), /*#__PURE__*/React.createElement(InlineList, {
    as: "span",
    itemAs: "span",
    spacing: "xs"
  }, /*#__PURE__*/React.createElement(Button, {
    ref: buttonRef,
    size: buttonSize,
    onClick: onCancel
  }, t('actions_keep')), /*#__PURE__*/React.createElement(Button, {
    variant: "important",
    size: buttonSize,
    onClick: onConfirm
  }, t('actions_delete')))));
}
export default DeleteConfirmation;